import React from 'react';
import { BookOpen, BookOpenText, Star, Lightbulb, PlayCircle, Settings, BarChart3, BarChart2, Gamepad2, Cpu } from 'lucide-react';
import { useLang, tx } from '../i18n/LanguageContext';
import { LibraryCard } from '../components/library/LibraryCard';
import { LIB_IMGS } from '../components/articles/articleUtils';
import { SIM_HERO_IMG } from '../components/simulations/simUtils';

export default function Library() {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const cards = [
    {
      to: '/articles', theme: 'blue', image: LIB_IMGS.articles, testId: 'library-card-articles',
      title: L('المقالات', 'Articles'),
      desc: L('مقالات وشروحات تقنية مفيدة في مجال الأتمتة الصناعية', 'Useful technical articles and guides in industrial automation'),
      cta: L('استعرض المقالات', 'Browse articles'),
      features: [
        { Icon: Lightbulb, label: L('شرح مبسط وسهل', 'Simple, easy explanations') },
        { Icon: Star, label: L('مواضيع متنوعة', 'Diverse topics') },
        { Icon: BookOpenText, label: L('+125 مقال', '125+ articles'), strong: true },
      ],
    },
    {
      to: '/videos', theme: 'red', image: LIB_IMGS.videos, testId: 'library-card-videos',
      title: L('الفيديوهات', 'Videos'),
      desc: L('فيديوهات تعليمية عملية وشروحات خطوة بخطوة', 'Practical educational videos, step by step'),
      cta: L('مشاهدة الفيديوهات', 'Watch videos'),
      features: [
        { Icon: BarChart3, label: L('جميع المستويات', 'All levels') },
        { Icon: Settings, label: L('شروحات عملية', 'Hands-on tutorials') },
        { Icon: PlayCircle, label: L('+250 فيديو', '250+ videos'), strong: true },
      ],
    },
    {
      to: '/simulations', theme: 'green', image: SIM_HERO_IMG, testId: 'library-card-simulations',
      title: L('المحاكاة التفاعلية', 'Interactive simulations'),
      desc: L('جرّب الأجهزة والدوائر وبرامج التحكم بشكل آمن وتفاعلي', 'Try devices, circuits and control programs safely and interactively'),
      cta: L('استكشف المحاكاة', 'Explore simulations'),
      features: [
        { Icon: Gamepad2, label: L('تجربة عملية', 'Hands-on practice') },
        { Icon: BarChart2, label: L('مستويات مختلفة', 'Different levels') },
        { Icon: Cpu, label: L('PLC ومحركات وحساسات', 'PLC, motors & sensors'), strong: true },
      ],
    },
  ];
  return (
    <main data-testid="library-page" className="relative page-y min-h-screen overflow-hidden">
      <img src={LIB_IMGS.articles} alt="" className="hidden lg:block absolute top-24 start-[4%] w-48 opacity-25 blur-[1px] -rotate-12 mix-blend-multiply pointer-events-none" />
      <img src={LIB_IMGS.videos} alt="" className="hidden lg:block absolute top-24 end-[4%] w-48 opacity-25 blur-[1px] rotate-12 mix-blend-multiply pointer-events-none" />
      <div className="relative site-container">
        <div className="text-center mb-8 sm:mb-10 art-reveal">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-blue-100/70 text-blue-700 text-sm font-bold mb-4">
            <BookOpen className="w-4 h-4" />{L('المكتبة', 'Library')}
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-[2.75rem] font-black text-slate-900 tracking-tight mb-3">{L('محتوى تعليمي متنوع', 'Diverse learning content')}</h1>
          <p className="text-slate-500 text-sm sm:text-base">{L('مقالات وفيديوهات ومحاكاة تفاعلية في مجال الأتمتة الصناعية', 'Articles, videos and interactive simulations in industrial automation')}</p>
        </div>
        <div className="grid md:grid-cols-3 gap-5 lg:gap-6">
          {cards.map((c, i) => <LibraryCard key={c.to} {...c} delay={i * 100} />)}
        </div>
      </div>
    </main>
  );
}
